import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { General, KeyboardShortcut } from "../../siteManagement/general";
import { EventType } from "../../siteManagement/eventManager";
import { Config } from "../core/config/config";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import React from "react";
export default class ReportSearch extends React.Component<any, any> {
    common = new AppHelper();
    private sheet: Sheet;
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private createNew = () => {
        const url = Config.baseUrl + "ReportMetaData/New";
        let sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.Close, () => { this.sheet.trigger(SheetEventType.Custom, {cmd: "reloadReportInfo"}) })
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return (
            <> 
                <CommonApp {...props} titleProps={""} />
                <FloatingsButtons onNewClick={this.createNew} />
            </>
        );
    }

    //return(
    //  <DragAndDrop handleDrop = { this.handleDrop } style = {{ height: "98%" }}>
    //      <CommonApp {...props} titleProps={""} />
    //      <FloatingsButtons onNewClick={this.createNew} onImportClick={this.onImportClick} />
    //  </DragAndDrop >
    //);
}

class FloatingsButtons extends React.Component<FloatingsButtonsProps, any>{

    constructor(props) {
        super(props)
        this.initApp();
    }

    private initApp = () => {
        General.Events.bind(EventType.ShortCut, (shortcut: KeyboardShortcut) => {
            if (shortcut.ctrl && shortcut.alt && shortcut.key === "n") {
                this.props.onNewClick();
            }
        });
    }

    private createNewButton = () => {
        return (
            <div id={kendo.guid()} className="sheet__action " style={{ backgroundColor: "#6a1b9a" }} onClick={this.props.onNewClick}>
                <i className="fal fa-plus fa-fw fa-2x"></i>
            </div>
        );
    }

    render() {
        return (
            <div className="sheet__actions sheet__actions--active">
                {this.createNewButton()}
            </div>
        );
    }
}

interface FloatingsButtonsProps {
    onNewClick: () => void,
}